import { FeatureFlags } from '../types';

export const SET_FEATURE_FLAG_TYPE = 'SET_FEATURE_FLAG' as const;
export type SetFeatureFlagPayload = Partial<FeatureFlags>;
export const setFeatureFlagAction = (payload: SetFeatureFlagPayload) => ({
  type: SET_FEATURE_FLAG_TYPE,
  payload
});

export type SetFeatureFlagAction = ReturnType<typeof setFeatureFlagAction>;
